import apiService from '../apiService'

export const usermanageController = configService => {
  const service = apiService(configService)

  return {
    BuyerList: params => {
      return service.post({
        url: `cms/buyer/getBuyer`,
        params,
      })
    },

    getUser: id => {
      return service.get({
        url: 'cms/buyer/getBuyer/' + id,
      })
    },

    getBuyerList: id => {
      return service.post({
        url: `cms/buyer/getBuyer/` + id,
      })
    },
    searchBuyerList: params => {
      return service.post({
        url: `cms/buyer/getBuyer`,
        params,
      })
    },

    deleteBuyerList: id => {
      return service.put({
        url: `cms/buyer/removeBuyer/` + id,
      })
    },

    createUser: params => {
      return service.post({
        url: `cms/buyer/create`,
        params,
      })
    },
    updateBuyerStatus: params => {
      return service.put({
        url: `cms/buyer/updateBuyerStatus`,
        params,
      })
    },
    updateBuyer: params => {
      return service.put({
        url: `cms/buyer/updateBuyer`,
        params,
      })
    },
    updateEmailBuyer: params => {
      return service.post({
        url: `cms/buyer/resendEmail`,
        params,
      })
    },
    getBuyerID: id => {
      return service.put({
        url: `cms/buyer/getBuyer/` + id,
      })
    },

    // getHistory: id => {
    //   return service.get({
    //     url: `cms/buyer/${id}/buyer-history`,
    //   })
    // },

    //Admin
    createUserAdmin: params => {
      return service.post({
        url: `cms/admin/create`,
        params,
      })
    },

    AdminList: () => {
      return service.post({
        url: `cms/admin/getAdmin`,
      })
    },

    getAdmin: id => {
      return service.get({
        url: 'cms/admin/getAdmin/' + id,
      })
    },

    updateAdminStatus: params => {
      return service.put({
        url: `cms/admin/updateAdminStatus`,
        params,
      })
    },

    // getAdminID: id => {
    //   return service.put({
    //     url: `cms/admin/getAdmin/` + id,
    //   })
    // },

    updateAdmin: params => {
      return service.put({
        url: `cms/admin/updateAdmin`,
        params,
      })
    },

    updateEmailAdmin: params => {
      return service.post({
        url: `cms/admin/resendEmail`,
        params,
      })
    },
    getListAdmin: params => {
      return service.post({
        url: 'cms/admin/getAdmin',
        params,
      })
    },
    deleteAdminById: id => {
      return service.put({
        url: `cms/admin/removeAdmin/` + id,
      })
    },

    //Supplier
    // createUserSupplier: params => {
    //   return service.post({
    //     url: `cms/supplier`,
    //     params,
    //   })
    // },
    // updateUserSupplier: params => {
    //   return service.put({
    //     url: `cms/supplier`,
    //     params,
    //   })
    // },
    getSuppliernById: id => {
      return service.get({
        url: `cms/supplier/` + id,
      })
    },
    deleteSupplierById: id => {
      return service.put({
        url: `cms/supplier/` + id + `/delete`,
      })
    },
    getListSupplier: params => {
      return service.get({
        url: `cms/supplier?sort_by=${params.sort_by}&sort_name=${params.sort_name}&keyword=${params.keyword}&page=${params.page}&role_id=${params.role_id}`,
        params,
      })
    },
    getCategories: params => {
      return service.get({
        url: `cms/buyer/event/category?company_id=${params.companyId}`,
      })
    },
    updateEmailSupplier: params => {
      return service.put({
        url: `cms/supplier-email`,
        params,
      })
    },
  }
}
